import { useRef, useState } from 'react';

import './InDepthCourses.scss';
import icons from '../../shared/assets/icons/redesign';
import { srcSet, useDimensions } from '../../helpers/image';
import Transition from '../Transition/Transition';
import CoursesLoginPopup from '../CoursesLoginPopup/CoursesLoginPopup';
import CoursesIntroAlternate from '../redesign/courses/CoursesIntroAlternate/CoursesIntroAlternate';

const { Dot, Check } = icons;

const courseList = [
  {
    name: 'borstvoedingscursus',
    displayName: 'Borstvoeding',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'sporten-en-bewegen',
    displayName: 'Sporten en bewegen',
    isBasis: true
  },
  {
    name: 'voedingscursus',
    displayName: 'Voeding',
    hasSubtitles: true,
    isBasis: true
  },
  {
    name: 'seksualiteit-tijdens-en-na-de-zwangerschap',
    displayName: 'Seksualiteit tijdens en na de zwangerschap',
    isBasis: true
  },
  {
    name: 'herstel-na-de-bevalling-sep',
    displayName: 'Herstel na de bevalling',
    isBasis: true
  },
  {
    name: 'de-eerste-100-dagen-na-de-bevalling',
    displayName: 'De eerste 100 dagen na de bevalling',
    isBasis: true
  },
  {
    name: 'dragen-en-hechting',
    displayName: 'Dragen en hechting'
  },
  {
    name: 'babymassage',
    displayName: 'Babymassage',
    hasSubtitles: true
  },
  {
    name: 'babysignalen-en-baby-en-kinder-gebaren',
    displayName: 'Babysignalen en baby en kinder gebaren'
  },
  {
    name: 'slaapcursus0-6maanden',
    displayName: 'Slaapcursus 0-6 maanden'
  },
  {
    name: 'slaapcursus-pakket',
    displayName: 'Slaapcursus 6 maanden tot 5 jaar'
  },
  {
    name: 'mindfulness-na-bevalling',
    displayName: 'Mindfullness na de bevalling'
  }
];

const plans = {
  basis: {
    normaal: '79,95',
    nu: '49,95',
    type: 'online-cursussen-ouder-en-kind-basis'
  },
  plus: {
    normaal: '139,95',
    nu: '59,95',
    type: 'online-cursussen-ouder-en-kind-plus'
  },
  pro: {
    normaal: '179,95',
    nu: '79,95',
    type: 'online-cursussen-ouder-en-kind-pro'
  }
};

export default function InDepthCourses({
  purchasedList = [],
  otherList = [],
  config,
  user,
  courses,
  userSubscriptions,
  addUserEvent
}) {
  const [popup, showPopup] = useState(false);
  const purchasedCourseImgRef = useRef();
  const purchasedCourseImgDimensions = useDimensions(purchasedCourseImgRef);
  const purchasedCourseAuthorImgRef = useRef();
  const purchasedCourseAuthorImgDimensions = useDimensions(
    purchasedCourseAuthorImgRef
  );
  const otherCourseImgRef = useRef();
  const otherCourseImgDimensions = useDimensions(otherCourseImgRef);

  return (
    <div className="inDepthCourses">
      <Transition on={popup}>
        <CoursesLoginPopup
          config={config}
          showPopup={showPopup}
          customList={[
            '18 meest populaire cursussen',
            'ruim 1500 min. aan professionele video’s',
            'vele ouders gingen je voor'
          ]}
        />
      </Transition>

      {!!purchasedList.length && (
        <div className="inDepthCourses-purchased">
          <h2 className="inDepthCourses-title">Gekochte Cursussen</h2>

          <ul className="inDepthCourses-purchased-list">
            {purchasedList.map(
              ({
                name,
                imageUrl,
                displayName,
                userImageUrl,
                username,
                isGroup
              }) => (
                <li className="inDepthCourses-purchased-list-item" key={name}>
                  <div
                    ref={purchasedCourseImgRef}
                    className="inDepthCourses-purchased-list-item-img"
                  >
                    {purchasedCourseImgDimensions && (
                      <img
                        alt="course-image"
                        srcSet={srcSet(imageUrl, purchasedCourseImgDimensions)}
                      />
                    )}
                  </div>

                  <h5 className="inDepthCourses-purchased-list-item-name">
                    {displayName}
                  </h5>

                  <div className="inDepthCourses-purchased-list-item-author">
                    <div
                      ref={purchasedCourseAuthorImgRef}
                      className="inDepthCourses-purchased-list-item-author-img"
                    >
                      {purchasedCourseAuthorImgDimensions && (
                        <img
                          alt="course-author-image"
                          srcSet={srcSet(
                            userImageUrl,
                            purchasedCourseAuthorImgDimensions
                          )}
                        />
                      )}
                    </div>

                    <span className="inDepthCourses-purchased-list-item-author-name">
                      {username}
                    </span>
                  </div>

                  <a
                    href={
                      isGroup
                        ? `/zwangerschapscursus/${name}`
                        : `/zwangerschapscursus/ouder-en-kind/${name}`
                    }
                    className="inDepthCourses-purchased-list-item-link"
                  >
                    Bekijken
                  </a>
                </li>
              )
            )}
          </ul>
        </div>
      )}

      <>
        <p className="coursesIntroAlternate-text">
          <h1 className="bold coursesIntroAlternate-title">
            Volg jouw ouder en kind cursus(sen) nu lekker vanuit huis!
          </h1>
          Een compleet cursusportaal waar je allemaal handige ouder en kind
          cursussen krijgt? Het bestaat. Met momenteel 12 cursussen zorgen onze
          professionals ervoor dat jij en je partner alles aankunnen wat er op
          jullie pad komt in de eerste levensjaren na de geboorte. Leer alles
          wat je wilt weten over het herstel na de bevalling en over wat er op
          je pad komt in de eerste levensjaren van je baby. Volg de cursus op
          jouw moment, in jouw veilige thuisomgeving.
        </p>

        <h3 className="coursesIntroAlternate-subtitle">Het cursusportaal:</h3>

        <ul className="coursesIntroAlternate-list">
          <li className="coursesIntroAlternate-list-item">
            <div className="coursesIntroAlternate-list-item-icon-wrap">
              <Check className="coursesIntroAlternate-list-item-icon" />
            </div>
            12 meest populaire cursussen
          </li>

          <li className="coursesIntroAlternate-list-item">
            <div className="coursesIntroAlternate-list-item-icon-wrap">
              <Check className="coursesIntroAlternate-list-item-icon" />
            </div>
            ruim 1000 min. aan professionele video’s
          </li>

          <li className="coursesIntroAlternate-list-item">
            <div className="coursesIntroAlternate-list-item-icon-wrap">
              <Check className="coursesIntroAlternate-list-item-icon" />
            </div>
            vele ouders gingen je voor
          </li>
        </ul>

        <CoursesIntroAlternate
          user={user}
          hideIntro
          plans={plans}
          config={config}
          courseList={courseList}
          addUserEvent={addUserEvent}
          userSubscriptions={userSubscriptions}
          list={courses.filter(({ isGroup }) => isGroup)}
        />
      </>

      {!!otherList.length && (
        <div className="inDepthCourses-other">
          <h2 className="inDepthCourses-title">Losse cursussen</h2>

          <ul className="inDepthCourses-other-list">
            {otherList.map(
              ({
                name,
                price,
                imageUrl,
                displayName,
                courseModules,
                paymentItemPrice
              }) => (
                <li key={name} className="inDepthCourses-other-list-item">
                  <a href={`/zwangerschapscursus/ouder-en-kind/${name}`}>
                    <div
                      ref={otherCourseImgRef}
                      className="inDepthCourses-other-list-item-img"
                    >
                      {otherCourseImgDimensions && (
                        <img
                          alt="course-image"
                          srcSet={srcSet(imageUrl, otherCourseImgDimensions)}
                        />
                      )}
                    </div>

                    <h5 className="inDepthCourses-other-list-item-name">
                      {displayName}
                    </h5>

                    <div className="inDepthCourses-other-list-item-meta">
                      <span className="inDepthCourses-other-list-item-meta-price">
                        €{paymentItemPrice || price || 0}
                      </span>

                      <Dot />

                      <span className="inDepthCourses-other-list-item-meta-video-count">
                        {courseModules.length}{' '}
                        {courseModules.length > 1 ? 'video’s' : 'video'}
                      </span>
                    </div>
                  </a>
                </li>
              )
            )}
          </ul>
        </div>
      )}

      <div className="inDepthCourses-footer">
        <h3 className="inDepthCourses-footer-title">About in-depth courses</h3>

        <p className="inDepthCourses-footer-text">
          Zwangerportaal’s in-depth courses are there to assist you during
          different chapters of your journey. Take the best care of yourself
          with the help from our trusted experts.
        </p>
      </div>
    </div>
  );
}
